import { IBriefProduct } from "./ibrief-product.interface";
import { BuyGetStatus } from "./buy-get-status.enum";
import { IPermissions } from "../../user/permissions/ipermissions/ipermissions.interface";
import { IFlyerDetailPagePositionCopy } from "../../../pages/flyer/types/flyer-detail-data/flyer-detail-page-position/flyer-detail-page-position.interface";
import { Language } from "../../language.type";
import { FlyerDetailPagePreviewProduct } from "../../../pages/flyer/pages/flyer-detail/pages/flyer-detail-page/types/flyer-detail-page-preview/flyer-detail-page-preview.interface";

export const hasBuyGetStatusNeither = (products: IBriefProduct[]): boolean =>
  products.some((product) => product.buyGetStatus === BuyGetStatus.Neither);

export const hasPromoPrice = (product: IBriefProduct): boolean => product.futurePrice !== null;

export const hasBuyGetStatusBuyAndNoRelatedProducts = (products: IBriefProduct[]): boolean =>
  products.some((product) => hasBuyGetStatusBuy(product) && !hasRelatedProducts(product));

export const hasBuyGetStatusBuy = (product: IBriefProduct): boolean =>
  product.buyGetStatus === BuyGetStatus.Buy;

export const hasRelatedProducts = (product: IBriefProduct): boolean =>
  Boolean(product.relatedGetProducts && product.relatedGetProducts.length > 0);

export const canDownloadProductsDetails = (
  products: IBriefProduct[],
  userPermissions: IPermissions
) => Boolean(products?.length && userPermissions.manageProducts);

export const isBuyOrGet = (status?: BuyGetStatus) =>
  [BuyGetStatus.Buy, BuyGetStatus.Get].includes(status!);

export const getBuyGetText = (status?: BuyGetStatus) => {
  switch (status) {
    case BuyGetStatus.Buy:
      return "Buy";
    case BuyGetStatus.Get:
      return "Get";
    default:
    case BuyGetStatus.Neither:
      return "Neither";
  }
};

export function getProductCopy(
  product: FlyerDetailPagePreviewProduct,
  copy: IFlyerDetailPagePositionCopy[],
  language: Language
): string {
  const locale = copy.find((cp) => cp.language === language);
  if (!locale) {
    return "";
  }

  return product.buyGetStatus === BuyGetStatus.Get ? locale.getCopyCard : locale.copyCard;
}

export function hasGetProducts(products?: IBriefProduct[]): boolean {
  return Boolean(
    products?.find((product: IBriefProduct) => product.buyGetStatus === BuyGetStatus.Get)
  );
}
